<div class="d-flex gap-2">
  <div
    *ngFor="let step of stepsArray; let i = index"
    class="step-indicator rounded-1 w-100"
    [class.active]="i <= currentStep"
  ></div>
</div>
